import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  MatTableModule,
  MatRow,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule, MatSort } from '@angular/material/sort';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDialog } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';

import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { NgFor, NgIf } from '@angular/common';
import {
  style,
  state,
  trigger,
  transition,
  animate,
} from '@angular/animations';
import { DialogService } from '../../services/dialogservice';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NotificationService } from '../../services/notificationservice';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HaulerService } from '../../services/haulerservice';
import { HaulerList } from '../../models/hauler.model';
import { AppDialogComponent } from '../common/app-dilaog/app-dialog.component';
import { HaulerDialogComponent } from '../haulers/Hauler-dilaog/hauler-dialog.component';
import { SiteDialogComponent } from './Site-dilaog/site-dialog.component';
import { SiteService } from '../../services/siteservice';
import { SiteList } from '../../models/site.model';
import { Regions } from '../../interfaces/regions';
import { LookUpService } from '../../services/lookupservice';
import { AttachDocumentsComponent } from './attach-documents/attach-documents.component';
import { ViewDocumentsComponent } from './view-documents/view-documents.component';
import { IdName } from '../../interfaces/pricematrixmodel';
import { ConfirmationDialogData, ConfirmationDialogComponent } from '../shared/components/confirmation-dialog/confirmation-dialog.component';
import { RolePermissionsService } from '../../services/role-permissions.service';
import { LoadScheduleControlFlags, ScreenName } from '../../interfaces/securityPermissions';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-markets',
  imports: [
    MatIcon,
    MatTableModule,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSelectModule,
    MatDatepickerModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './sites.component.html',
  styleUrl: './sites.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class SitesComponent {
  permissions = inject(RolePermissionsService);
  displayedColumns: string[] = [
    'actions',
    'sid',
    'siteName',
    'siteTypeName',
    'isRevenue',
    'isActive',
    'address1',
    'address2',
    'city',
    'state',
    'zipCode',
    'regionNames',
    'contactName',
    'contactEmail',
    'contactNumber',
    'volume',
    'manure_Goal',
    'ssO_Goal',
    'chP_Capacity',
    'cH4_Low_Heating_value',
    'conversion_BTU',
    'normal_CHGP_Efficiency',
    'specialInstructions',
    'disposalMethodNames',
    'oracleAccountNumber',
    'oracleSiteNumber',
  ];
  dataSource = new MatTableDataSource<any>();
  filterText: string = '';
  markets: Regions[] = [];
  filteredMarkets: Regions[] = [];
  siteTypes : IdName[] = [];
  siteList: SiteList[] = [];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @Output('onFormSubmit') formEmitter = new EventEmitter<any>();
  isDataLoaded = false;
  selectedMarket: number = -1;
  selectedSiteType: number = -1;
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();
  constructor(
    private _dialog: MatDialog,
    private siteService: SiteService,
    private lookUp: LookUpService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private route: ActivatedRoute,
    private rolesService: RoleService
  ) {}
  ngOnInit(): void {
    this.getMarkets();
    this.getMarketsData();
    this.getsiteTypesData();
  }

  getsiteTypesData(): void {
    this.lookUp.getSiteTypes().subscribe({
      next: (response: IdName[]) => {
        this.siteTypes = response;
      }
    });
  }

  getMarkets() {
    this.isDataLoaded = false;    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.Sites, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
        console.log("Sites permissions ", perms);
      }
    })
    this.siteService.getSiteDataBySiteTypeMarket(this.selectedMarket, this.selectedSiteType).subscribe({
      next: (res: SiteList[]) => {
        console.log("sites resp", res);
        this.siteList = res;
        if (this.isDataLoaded == false) {
        }
        this.isDataLoaded = true;

        this.dataSource = new MatTableDataSource(this.siteList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.syncFilter();
      },
      error: (err: HttpErrorResponse) => {
        console.log(err);
        this.notificationService.show(err.message, 'error');
        this.isDataLoaded = true;
      },
    });
  }

  getMarketsData(): void {
    this.lookUp.getMarketsList('').subscribe({
      next: (response: Regions[]) => {
        this.markets = response;
        this.filteredMarkets = response;
      },
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filterText = filterValue; // Store the current text
    this.syncFilter();
  }
  syncFilter() {
    if (this.dataSource) {
      this.dataSource.filter = this.filterText.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }
  openContextmenu(data: any, action: any) {
    if (action == 'EDIT') {
      this.openSiteForm(false, data);
    } else if (action == 'ATTACH') {
      console.log('Attach ', data);
      this.openAttachmentForm(false, data, data.siteName);
    } else if (action == 'VIEWDOC') {
      console.log('View Docs ', data);
      this.OpenDocumentsDetails(false, data, data.siteName);
    } else if (action == 'DELETE') {
      console.log('delte record ', data);
      this.deleteSiteRecord(data);
    }
  }
  openAttachmentForm(arg0: boolean, data: any, siteName: string) {
    const dialogRef = this._dialog.open(AttachDocumentsComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'attachDocumentsDialogCompact',
      maxHeight: '90vh',
      data: { sid: data.id, siteName: siteName }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        //console.log('Data received:', result.data);
        this.fetchData();
      }
    });
  }

  OpenDocumentsDetails(arg0: boolean, data: any, siteName: string) {
    const dialogRef = this._dialog.open(ViewDocumentsComponent, {      
      panelClass: 'big-dialog',
      width: '800px',
      //height:'250px',
      data: {
        loadScheduleId: data.id,
        screenTypeId: 2,
        name: siteName,
        canShowGridActions: true
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');      
      if(result){
        this.fetchData();   
      }   
    });
  }

  deleteSiteRecord(data: any) {
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete record?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        console.log('delete record:', data);
        this.handleDeleteSiteRecord(data.id);
      }
    });
  }

  handleDeleteSiteRecord(id: any) {
    this.siteService.deleteSite(id).subscribe({
      next: (response: any) => {
        this.formEmitter.emit({ submit: true });
        this.notificationService.show('Site deleted successfully', 'success');
        this.fetchData();
      }
    });
  }

  openSiteForm(isAdd?: any, formData?: any): void {
    console.log(
      'openSiteForm called with isAdd:',
      isAdd,
      'formData:',
      formData
    );
    const dialogRef = this._dialog.open(SiteDialogComponent, {
      width: '1000px',
      disableClose:true,
      data: {
        title: isAdd ? 'Add Site' : 'Edit Site',
        formData: isAdd ? {} : formData || {},
        isAddForm: isAdd || false,
        canSave: this.controlPermissions.addButton || this.controlPermissions.edit
      }, // Pass your input data object here
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Data received:', result);
      if (result) {
        //console.log('Data received:', result.data);
        this.getMarkets();
      }
    });
  }

  getSites() {
    this.isDataLoaded = false;
    this.siteService.getSiteList().subscribe({
      next: (res: SiteList[]) => {
        this.siteList = res;
        if (this.isDataLoaded == false) {
        }
        this.isDataLoaded = true;
        console.log('Data fetched successfully:', res);
        this.dataSource = new MatTableDataSource(this.siteList);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });
  }

  onMarketChange(marketId: number) {
    this.selectedMarket = marketId;
    if (this.selectedMarket == null || this.selectedMarket == undefined) {
      this.selectedMarket = -1;
    }
    this.fetchData();
  }

  onSiteTypeChange(siteTypeId: number) {
    this.selectedSiteType = siteTypeId;
    if (this.selectedSiteType == null || this.selectedSiteType == undefined) {
      this.selectedSiteType = -1;
    }
    this.fetchData();
  }

  fetchData() {
    this.siteService.getSiteDataBySiteTypeMarket(this.selectedMarket, this.selectedSiteType).subscribe((response: SiteList[]) => {
      console.log('Data fetched successfully:', response);
      this.siteList = response;
      if (this.isDataLoaded == false) {
      }
      this.isDataLoaded = true;

      this.dataSource = new MatTableDataSource(this.siteList);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      // Handle the response
      this.syncFilter();
    });
  }  

  filterMarkets(event: Event): void {
    const searchTerm = (event.target as HTMLInputElement).value.toLowerCase();
    if (!searchTerm) {
      this.filteredMarkets = [...this.markets];
    } else {
      this.filteredMarkets = this.markets.filter(
        market => market.regionName.toLowerCase().includes(searchTerm)
      );
    }
  }
}
